import { useEffect } from 'react'

import _ from 'lodash'


import { LevelPlayQuestionMultipleChoice } from './MultipleChoice'
import { LevelPlayQuestionQRCode } from './QRCode'
import { LevelPlayQuestionText } from './Text'

const QR_CODE = 'qr_code'
const TEXT = 'text'
const MULTIPLE_CHOICE = 'multiple_choice'
const QUESTION_KINDS = {
  [QR_CODE]: LevelPlayQuestionQRCode,
  [TEXT]: LevelPlayQuestionText,
  [MULTIPLE_CHOICE]: LevelPlayQuestionMultipleChoice
}

export const LevelPlayQuestion = ({ activity }) => {
  const { meta } = activity
  const kind = _.get(meta, 'question_kind', TEXT) || TEXT
  const QuestionKindComponent = _.get(QUESTION_KINDS, kind)

  return <QuestionKindComponent meta={meta} activity={activity} />
}
